import type { FC } from 'react';

export type ErrorMessageProps = {
  message: string | undefined;
  show: boolean;
  id?: string;
};

/**
 * Accessible error message display for datepicker validation.
 */
export const ErrorMessage: FC<ErrorMessageProps> = ({ message, show, id }) => {
  if (!show || !message) {
    return null;
  }

  return (
    <div
      id={id}
      role="alert"
      aria-live="polite"
      className="text-color-comp-form-label-danger font-comp-form-sub-text-font-family font-comp-form-sub-text-font-size leading-font-comp-form-sub-text-line-height mt-1"
    >
      {message}
    </div>
  );
};
